import React, { useEffect, useRef, useState } from 'react';
import coupleIllustration from '../assets/wedding-couple-illustration-cropped.png';
import coupleHugVideo from '../assets/Bride_and_groom_hugging_202608232053.mp4';
import backgroundMusic from '../assets/Edd_Sheeran_-_Perfect_(mp3.pm).mp3';
import poruwaIcon from '../assets/Poruwa.png';
import mealIcon from '../assets/meal.png';
import salsaIcon from '../assets/salsa.png';
import toastIcon from '../assets/wedding Toast.png';
import cakeIcon from '../assets/wedding-cake.png';
import weddingCarIcon from '../assets/wedding-car.png';

const wedding = {
  bride: 'Nimesha',
  groom: 'Kavinda',
  day: '29',
  month: 'October',
  year: '2026',
  time: '9.00 AM onwards',
  venue: 'Vinrich Lake Resort',
  address: 'Piliyandala, Sri Lanka',
  mapUrl:
    'https://www.google.com/maps/search/?api=1&query=Vinrich+Lake+Resort+Piliyandala',
};

const eventSchedule = [
  { time: '09.00 AM', label: 'Poruwa Ceremony', note: 'Blessings, promises & happy tears', icon: 'ceremony' },
  { time: '10.30 AM', label: 'Welcome Toast', note: 'A warm welcome as we begin the celebration', icon: 'celebration' },
  { time: '', label: 'Cake Cutting', note: 'Sweet beginnings and happy smiles', icon: 'cake' },
  { time: '', label: 'Lunch', note: 'A delicious feast shared with loved ones', icon: 'lunch' },
  { time: '', label: 'Dance Floor', note: 'Let the music, laughter & joy begin', icon: 'dance' },
  { time: '4.00 PM', label: "Couple's Exit", note: 'Send us off with love as our forever begins', icon: 'farewell' },
];

const RSVP_WEBHOOK_URL = process.env.REACT_APP_RSVP_WEBHOOK_URL ||
  'https://script.google.com/macros/s/AKfycbyekwBKEOdJGX0an8ZH4V7E5MjwjitC1Y9NuEoo7X6lh1_uUHcUzO7-111xmvXekBpm/exec';

const eventIconAssets = {
  ceremony: poruwaIcon,
  celebration: toastIcon,
  cake: cakeIcon,
  lunch: mealIcon,
  dance: salsaIcon,
  farewell: weddingCarIcon,
};

function EventIcon({ type }) {
  return <img src={eventIconAssets[type] || toastIcon} alt="" />;
}

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Cormorant+Garamond:wght@400;500;600;700&family=Great+Vibes&display=swap');

  :root {
    --rose: #c7a77b;
    --rose-deep: #9a7650;
    --rose-dark: #5f4b38;
    --ink: #44372b;
    --muted: #897866;
    --blush: #f3eee6;
    --paper: #fffdf8;
    --line: rgba(154, 118, 80, 0.24);
  }

  * { box-sizing: border-box; }

  html { scroll-behavior: smooth; }

  body {
    margin: 0;
    color: var(--ink);
    background: #f6f0e7;
    font-family: 'DM Sans', sans-serif;
  }

  button, input, select { font: inherit; }
  button, a { -webkit-tap-highlight-color: transparent; }
  a { color: inherit; text-decoration: none; }

  .invitation {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    background: #fefbf6;
  }

  .invitation::before,
  .invitation::after {
    position: fixed;
    z-index: 0;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    content: '';
    filter: blur(3px);
    opacity: 0.55;
    pointer-events: none;
  }

  .invitation::before {
    top: -140px;
    left: -130px;
    background: #eee5d8;
  }

  .invitation::after {
    right: -120px;
    bottom: 14%;
    background: #f2e9dc;
  }

  .invite-page {
    position: relative;
    z-index: 1;
    width: min(100%, 520px);
    margin: 0 auto;
    overflow: hidden;
    background: var(--paper);
    box-shadow: 0 0 70px rgba(106, 48, 61, 0.17);
  }

  .music-toggle {
    position: fixed;
    z-index: 12;
    top: 18px;
    right: max(18px, calc((100vw - 520px) / 2 + 18px));
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 38px;
    padding: 0 13px;
    border: 1px solid rgba(169, 94, 107, 0.28);
    border-radius: 999px;
    color: var(--rose-deep);
    background: rgba(255, 250, 250, 0.85);
    box-shadow: 0 8px 24px rgba(106, 48, 61, 0.1);
    backdrop-filter: blur(12px);
    cursor: pointer;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  .music-bars {
    display: inline-flex;
    align-items: end;
    gap: 2px;
    width: 13px;
    height: 13px;
  }

  .music-bars i {
    display: block;
    width: 3px;
    border-radius: 3px;
    background: currentColor;
  }

  .music-bars i:nth-child(1) { height: 7px; }
  .music-bars i:nth-child(2) { height: 12px; animation-delay: 140ms; }
  .music-bars i:nth-child(3) { height: 9px; animation-delay: 260ms; }
  .music-toggle.is-playing .music-bars i { animation: musicBars 900ms ease-in-out infinite alternate; }

  .background-audio { display: none; }

  .cover {
    position: relative;
    min-height: 820px;
    padding: 92px 28px 30px;
    overflow: hidden;
    isolation: isolate;
    background:
      radial-gradient(circle at 0% 0%, rgba(224, 207, 184, 0.42), transparent 28%),
      radial-gradient(circle at 100% 0%, rgba(234, 218, 198, 0.38), transparent 28%),
      radial-gradient(circle at 0% 100%, rgba(239, 224, 207, 0.34), transparent 30%),
      radial-gradient(circle at 100% 100%, rgba(226, 207, 184, 0.32), transparent 30%),
      radial-gradient(circle at 50% 30%, rgba(255,255,255,0.68), transparent 34%),
      linear-gradient(180deg, #f8f1e7 0%, #fefcf8 54%, #fdfaf4 100%);
    text-align: center;
  }

  .nature-scene {
    position: fixed;
    z-index: 2;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
  }

  .falling-leaf {
    position: absolute;
    top: -28px;
    left: var(--leaf-left);
    width: 13px;
    height: 8px;
    border-radius: 100% 0 100% 0;
    background: #6f9b43;
    opacity: 0;
    animation: leafFall var(--leaf-duration) linear infinite;
  }

  .falling-leaf:nth-child(2n) { width: 10px; height: 6px; background: #a4c568; }
  .falling-leaf:nth-child(3n) { background: #5f8f3d; }

  .falling-leaf-1 { --leaf-left: 18%; --leaf-duration: 17s; --leaf-delay: -5s; --leaf-drift: 34px; --leaf-drift-end: -18px; --leaf-rotation: 20deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-2 { --leaf-left: 33%; --leaf-duration: 21s; --leaf-delay: -13s; --leaf-drift: -28px; --leaf-drift-end: 20px; --leaf-rotation: -32deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-3 { --leaf-left: 49%; --leaf-duration: 19s; --leaf-delay: -8s; --leaf-drift: 42px; --leaf-drift-end: -26px; --leaf-rotation: 40deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-4 { --leaf-left: 65%; --leaf-duration: 23s; --leaf-delay: -17s; --leaf-drift: -36px; --leaf-drift-end: 24px; --leaf-rotation: -18deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-5 { --leaf-left: 78%; --leaf-duration: 18s; --leaf-delay: -3s; --leaf-drift: 27px; --leaf-drift-end: -16px; --leaf-rotation: 28deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-6 { --leaf-left: 88%; --leaf-duration: 22s; --leaf-delay: -11s; --leaf-drift: -42px; --leaf-drift-end: 18px; --leaf-rotation: -25deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-7 { --leaf-left: 8%; --leaf-duration: 20s; --leaf-delay: -9s; --leaf-drift: -24px; --leaf-drift-end: 18px; --leaf-rotation: 35deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-8 { --leaf-left: 26%; --leaf-duration: 24s; --leaf-delay: -19s; --leaf-drift: 38px; --leaf-drift-end: -24px; --leaf-rotation: -15deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-9 { --leaf-left: 41%; --leaf-duration: 18s; --leaf-delay: -4s; --leaf-drift: -31px; --leaf-drift-end: 22px; --leaf-rotation: 26deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-10 { --leaf-left: 57%; --leaf-duration: 22s; --leaf-delay: -15s; --leaf-drift: 29px; --leaf-drift-end: -20px; --leaf-rotation: -38deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-11 { --leaf-left: 72%; --leaf-duration: 25s; --leaf-delay: -7s; --leaf-drift: -35px; --leaf-drift-end: 26px; --leaf-rotation: 18deg; animation-delay: var(--leaf-delay); }
  .falling-leaf-12 { --leaf-left: 96%; --leaf-duration: 19s; --leaf-delay: -16s; --leaf-drift: 24px; --leaf-drift-end: -17px; --leaf-rotation: -30deg; animation-delay: var(--leaf-delay); }

  @keyframes leafFall {
    0% { opacity: 0; transform: translate3d(0, -30px, 0) rotate(var(--leaf-rotation)); }
    12% { opacity: 0.68; }
    52% { opacity: 0.52; transform: translate3d(var(--leaf-drift), 50vh, 0) rotate(calc(var(--leaf-rotation) + 180deg)); }
    100% { opacity: 0; transform: translate3d(var(--leaf-drift-end), 110vh, 0) rotate(calc(var(--leaf-rotation) + 380deg)); }
  }

  @keyframes edgeLeafSway {
    0%, 100% { transform: rotate(var(--leaf-angle)) translateY(0); }
    50% { transform: rotate(calc(var(--leaf-angle) + 5deg)) translateY(-2px); }
  }

  .cover::before {
    position: absolute;
    z-index: -1;
    inset: 18px;
    border: 1px solid rgba(255, 255, 255, 0.66);
    content: '';
    pointer-events: none;
  }

  .cover::after {
    position: absolute;
    z-index: -1;
    inset: 28px;
    border: 1px solid rgba(169, 94, 107, 0.13);
    content: '';
    pointer-events: none;
  }

  .cover-topline {
    display: flex;
    justify-content: space-between;
    color: rgba(98, 61, 69, 0.68);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
  }

  .cover-couple-frame {
    position: relative;
    display: block;
    width: min(360px, 88%);
    height: 220px;
    margin: 30px auto 2px;
    overflow: hidden;
    animation: coupleHugMotion 8s ease-in-out infinite;
    transform-origin: center bottom;
    will-change: transform;
  }

  .cover-leaf-frame {
    position: absolute;
    z-index: 3;
    inset: 0;
    pointer-events: none;
  }

  .cover-leaf {
    position: absolute;
    width: 18px;
    height: 10px;
    border-radius: 100% 0 100% 0;
    background: #84a957;
    box-shadow: 1px 2px 4px rgba(70, 92, 42, 0.12);
    opacity: 0.8;
    transform: rotate(var(--leaf-angle));
    animation: edgeLeafSway 5s ease-in-out infinite;
  }

  .cover-leaf:nth-child(2n) { width: 14px; height: 8px; background: #a6bf70; }
  .cover-leaf:nth-child(3n) { background: #6f9648; }

  .cover-leaf-top-1 { top: 4px; left: 12%; --leaf-angle: 26deg; }
  .cover-leaf-top-2 { top: 11px; left: 31%; --leaf-angle: -22deg; animation-delay: -1.2s; }
  .cover-leaf-top-3 { top: 3px; left: 56%; --leaf-angle: 34deg; animation-delay: -2.6s; }
  .cover-leaf-top-4 { top: 14px; right: 12%; --leaf-angle: -28deg; animation-delay: -3.8s; }
  .cover-leaf-right-1 { top: 28%; right: 5px; --leaf-angle: 42deg; animation-delay: -1.8s; }
  .cover-leaf-right-2 { top: 54%; right: 2px; --leaf-angle: -34deg; animation-delay: -4.5s; }
  .cover-leaf-right-3 { top: 78%; right: 10px; --leaf-angle: 28deg; animation-delay: -2.2s; }
  .cover-leaf-bottom-1 { bottom: 6px; right: 22%; --leaf-angle: -32deg; animation-delay: -3.3s; }
  .cover-leaf-bottom-2 { bottom: 10px; left: 43%; --leaf-angle: 24deg; animation-delay: -1.5s; }
  .cover-leaf-bottom-3 { bottom: 4px; left: 16%; --leaf-angle: -25deg; animation-delay: -4.1s; }
  .cover-leaf-left-1 { top: 72%; left: 4px; --leaf-angle: 38deg; animation-delay: -2.8s; }
  .cover-leaf-left-2 { top: 45%; left: 1px; --leaf-angle: -30deg; animation-delay: -4.8s; }
  .cover-leaf-left-3 { top: 22%; left: 8px; --leaf-angle: 22deg; animation-delay: -0.8s; }

  .cover-couple-gif {
    position: relative;
    z-index: 0;
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    outline: none;
    background: transparent;
    box-shadow: none;
    object-fit: contain;
    filter: brightness(1.06) saturate(0.88) sepia(0.05);
    -webkit-mask-image: radial-gradient(ellipse at center, #000 24%, rgba(0, 0, 0, 0.76) 54%, transparent 88%);
    mask-image: radial-gradient(ellipse at center, #000 24%, rgba(0, 0, 0, 0.76) 54%, transparent 88%);
  }

  .cover-kicker {
    position: relative;
    margin: 0;
    color: var(--rose-deep);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.24em;
    text-transform: uppercase;
  }

  .names {
    margin: 22px 0 0;
    color: var(--rose-dark);
    font-family: 'Great Vibes', cursive;
    font-size: clamp(68px, 17vw, 92px);
    font-weight: 400;
    line-height: 0.82;
  }

  .names span { display: block; }
  .names .ampersand {
    margin: 10px 0 4px;
    color: var(--rose-deep);
    font-family: 'Cormorant Garamond', serif;
    font-size: 28px;
    font-style: italic;
    line-height: 0.7;
  }

  .ornament {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin: 23px auto 0;
    color: var(--rose-deep);
  }

  .ornament::before,
  .ornament::after {
    width: 74px;
    height: 1px;
    background: var(--line);
    content: '';
  }

  .ornament span { transform: rotate(45deg); font-size: 11px; }

  .cover-call {
    margin: 17px 0 0;
    color: var(--muted);
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    font-style: italic;
  }

  .date-lockup {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin: 18px auto 0;
    color: var(--rose-dark);
    font-family: 'Cormorant Garamond', serif;
  }

  .date-lockup .day {
    font-size: 74px;
    font-weight: 600;
    line-height: 0.7;
  }

  .date-lockup .month-year {
    display: grid;
    gap: 2px;
    padding-left: 16px;
    border-left: 1px solid var(--line);
    text-align: left;
  }

  .date-lockup strong { font-size: 20px; font-weight: 600; letter-spacing: 0.16em; }
  .date-lockup small { font-size: 16px; letter-spacing: 0.2em; }

  .join-button {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-height: 44px;
    margin: 25px 0 36px;
    padding: 0 24px;
    border: 1px solid rgba(169, 94, 107, 0.22);
    border-radius: 999px;
    color: var(--rose-dark);
    background: rgba(255, 250, 249, 0.34);
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.8);
    cursor: pointer;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.26em;
    text-transform: uppercase;
    transition: transform 180ms ease, background 180ms ease;
  }

  .join-button:hover { transform: translateY(-2px); background: rgba(255, 250, 249, 0.68); }

  .cover-venue {
    position: absolute;
    right: 28px;
    bottom: 44px;
    left: 28px;
    margin: 0;
    color: rgba(98, 61, 69, 0.74);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.2em;
  }

  .cover-venue span { margin: 0 8px; color: var(--rose-deep); }

  .section {
    position: relative;
    padding: 74px 28px;
    background: var(--paper);
  }

  .section.soft { background: #fefaf4; }

  .section::before {
    position: absolute;
    top: 22px;
    right: -34px;
    width: 155px;
    height: 155px;
    border: 1px solid rgba(169,94,107,0.1);
    border-radius: 50%;
    content: '';
  }

  .eyebrow {
    margin: 0;
    color: var(--rose-deep);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.28em;
    text-align: center;
    text-transform: uppercase;
  }

  .section-title {
    margin: 12px 0 0;
    color: var(--rose-dark);
    font-family: 'Great Vibes', cursive;
    font-size: 52px;
    font-weight: 400;
    line-height: 1;
    text-align: center;
  }

  .section-copy {
    max-width: 360px;
    margin: 18px auto 0;
    color: var(--muted);
    font-family: 'Cormorant Garamond', serif;
    font-size: 21px;
    line-height: 1.35;
    text-align: center;
  }

  .intro-quote {
    margin: 28px auto 0;
    padding: 18px 22px;
    border-block: 1px solid var(--line);
    color: var(--rose-dark);
    font-family: 'Cormorant Garamond', serif;
    font-size: 21px;
    font-style: italic;
    line-height: 1.3;
    text-align: center;
  }

  .countdown {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    margin-top: 32px;
  }

  .countdown-card {
    padding: 13px 5px 11px;
    border: 1px solid rgba(169, 94, 107, 0.15);
    background: rgba(249, 231, 231, 0.5);
    text-align: center;
  }

  .countdown-card strong {
    display: block;
    color: var(--rose-deep);
    font-family: 'Cormorant Garamond', serif;
    font-size: 27px;
    font-weight: 600;
    line-height: 1;
  }

  .countdown-card span {
    display: block;
    margin-top: 5px;
    color: var(--muted);
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .section-heading-row {
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 24px;
  }

  .section-heading-row .eyebrow { text-align: left; }
  .section-heading-row .section-title { margin-top: 8px; text-align: left; }
  .mini-script { color: var(--rose-deep); font-family: 'Great Vibes', cursive; font-size: 30px; }

  .schedule {
    position: relative;
    display: grid;
    gap: 0;
    margin-top: 32px;
    padding: 8px 0;
  }

  .schedule::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    background: var(--line);
    content: '';
    transform: translateX(-50%);
  }

  .schedule-item {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 26px minmax(0, 1fr);
    gap: 12px;
    min-height: 156px;
    padding: 13px 0;
  }

  .schedule-content {
    align-self: start;
    padding-top: 2px;
  }

  .schedule-item-left .schedule-content {
    grid-column: 1;
    text-align: right;
  }

  .schedule-item-right .schedule-content {
    grid-column: 3;
    text-align: left;
  }

  .schedule-time {
    display: block;
    color: var(--rose-deep);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
  }

  .schedule-icon {
    width: 46px;
    height: 46px;
    margin-bottom: 8px;
    color: var(--rose-deep);
    opacity: 0.82;
  }

  .schedule-icon img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    mix-blend-mode: multiply;
  }

  .schedule-item-left .schedule-icon { margin-left: auto; }
  .schedule-item-right .schedule-icon { margin-right: auto; }

  .schedule-node {
    position: absolute;
    top: 20px;
    left: 50%;
    width: 13px;
    height: 13px;
    border: 3px solid var(--paper);
    border-radius: 50%;
    background: var(--rose-deep);
    box-shadow: 0 0 0 1px rgba(154, 118, 80, 0.42);
    content: '';
    transform: translateX(-50%);
  }

  .schedule-label { margin: 0; color: var(--rose-dark); font-family: 'Cormorant Garamond', serif; font-size: 25px; font-weight: 600; }
  .schedule-note { margin: 4px 0 0; color: var(--muted); font-size: 12px; line-height: 1.4; }

  .timeline-heading {
    margin-bottom: 4px;
    text-align: center;
  }

  .timeline-title {
    margin: 12px 0 0;
    color: var(--rose-dark);
    font-family: 'Cormorant Garamond', serif;
    font-size: clamp(34px, 9vw, 46px);
    font-weight: 500;
    letter-spacing: 0.08em;
    line-height: 0.95;
    text-transform: uppercase;
  }

  .venue-panel {
    margin-top: 26px;
    padding: 22px;
    border: 1px solid var(--line);
    background: linear-gradient(140deg, #f8efe3, #fffdf8);
    text-align: center;
  }

  .venue-panel .venue-name { margin: 0; color: var(--rose-dark); font-family: 'Cormorant Garamond', serif; font-size: 29px; font-weight: 600; }
  .venue-panel .venue-address { margin: 5px 0 0; color: var(--muted); font-size: 12px; }

  .map-preview {
    display: block;
    width: 100%;
    height: 148px;
    margin-top: 18px;
    border: 1px solid var(--line);
    filter: sepia(0.12) saturate(0.72);
  }

  .text-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 17px;
    color: var(--rose-deep);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .text-link::after { content: '↗'; font-size: 15px; }

  .story-section { padding-bottom: 62px; text-align: center; }

  .couple-image {
    display: block;
    width: 100%;
    max-width: 360px;
    margin: 28px auto 0;
    mix-blend-mode: multiply;
    opacity: 0.84;
    animation: coupleHugMotion 8s ease-in-out infinite;
    transform-origin: center bottom;
    will-change: transform;
  }

  .rsvp-card {
    margin-top: 26px;
    padding: 23px;
    border: 1px solid var(--line);
    background: #fffdf8;
  }

  .field { display: grid; gap: 7px; margin-bottom: 14px; text-align: left; }
  .field label { color: var(--muted); font-size: 9px; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase; }
  .field input, .field select {
    width: 100%;
    min-height: 44px;
    padding: 0 13px;
    border: 1px solid rgba(169,94,107,0.2);
    border-radius: 0;
    outline: none;
    color: var(--ink);
    background: #fff;
  }
  .field input:focus, .field select:focus { border-color: var(--rose); box-shadow: 0 0 0 3px rgba(213,151,157,0.15); }

  .submit-button {
    width: 100%;
    min-height: 46px;
    border: 0;
    background: var(--rose-deep);
    color: #fff;
    cursor: pointer;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    transition: background 180ms ease, transform 180ms ease;
  }
  .submit-button:hover { transform: translateY(-1px); background: var(--rose-dark); }
  .submit-button:disabled { cursor: wait; opacity: 0.65; transform: none; }

  .thanks { margin: 12px 0 0; color: var(--rose-deep); font-family: 'Cormorant Garamond', serif; font-size: 20px; }
  .form-error { margin: 12px 0 0; color: #a34f45; font-size: 12px; line-height: 1.45; }

  .footer {
    padding: 40px 28px 48px;
    background: #faf3e9;
    color: var(--rose-dark);
    text-align: center;
  }
  .footer-script { margin: 0; font-family: 'Great Vibes', cursive; font-size: 42px; }
  .footer-copy { margin: 9px 0 0; color: var(--muted); font-size: 10px; letter-spacing: 0.14em; text-transform: uppercase; }

  @keyframes musicBars { from { transform: scaleY(0.45); } to { transform: scaleY(1); } }

  @keyframes coupleHugMotion {
    0%, 100% { transform: translateY(0) scale(1); }
    50% { transform: translateY(-6px) scale(1.015); }
  }

  @media (min-width: 521px) {
    .invite-page { margin: 24px auto; border-radius: 8px; }
    .cover { border-radius: 8px 8px 0 0; }
  }

  @media (max-width: 390px) {
    .cover { min-height: 760px; padding-inline: 22px; }
    .names { font-size: 66px; }
    .cover-venue { right: 22px; left: 22px; font-size: 8px; }
    .section { padding-inline: 22px; }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after { scroll-behavior: auto !important; animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; }
  }
`;

function Invite() {
  const audioRef = useRef(null);
  const [musicPlaying, setMusicPlaying] = useState(false);
  const [countdown, setCountdown] = useState({ days: '000', hours: '00', minutes: '00', seconds: '00' });
  const [rsvpSent, setRsvpSent] = useState(false);
  const [rsvpSubmitting, setRsvpSubmitting] = useState(false);
  const [rsvpError, setRsvpError] = useState('');

  useEffect(() => {
    const updateCountdown = () => {
      const target = new Date('2026-10-29T09:00:00+05:30').getTime();
      const remaining = Math.max(target - Date.now(), 0);
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setCountdown({
        days: String(days).padStart(3, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      });
    };

    updateCountdown();
    const interval = window.setInterval(updateCountdown, 1000);
    return () => window.clearInterval(interval);
  }, []);

  const stopMusic = () => {
    audioRef.current?.pause();
    setMusicPlaying(false);
  };

  const playMusic = async () => {
    if (!audioRef.current) return;

    try {
      await audioRef.current.play();
      setMusicPlaying(true);
    } catch (error) {
      setMusicPlaying(false);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return undefined;

    audio.volume = 0.35;
    const removeUnlockListeners = () => {
      document.removeEventListener('pointerdown', startAudio);
      document.removeEventListener('keydown', startAudio);
    };
    const startAudio = () => {
      audio.play()
        .then(() => {
          setMusicPlaying(true);
          removeUnlockListeners();
        })
        .catch(() => setMusicPlaying(false));
    };

    document.addEventListener('pointerdown', startAudio, { once: true });
    document.addEventListener('keydown', startAudio, { once: true });
    startAudio();

    return () => {
      removeUnlockListeners();
      audio.pause();
    };
  }, []);

  const toggleMusic = () => (musicPlaying ? stopMusic() : playMusic());

  const scrollToDetails = () => document.getElementById('details')?.scrollIntoView({ behavior: 'smooth' });

  const submitRsvp = async (event) => {
    event.preventDefault();
    setRsvpError('');
    setRsvpSubmitting(true);

    const formData = new FormData(event.currentTarget);
    const payload = {
      name: formData.get('guestName'),
      mobile: formData.get('guestMobile'),
      type: formData.get('attendance'),
      pageUrl: window.location.href,
    };

    try {
      // text/plain keeps this request simple so Apps Script can receive the JSON body without a preflight.
      await fetch(RSVP_WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      });
      setRsvpSent(true);
    } catch (error) {
      setRsvpError('We could not send your RSVP. Please try again.');
    } finally {
      setRsvpSubmitting(false);
    }
  };

  return (
    <>
      <style>{css}</style>
      <main className="invitation">
        <div className="nature-scene" aria-hidden="true">
          <div className="falling-leaves">
            <i className="falling-leaf falling-leaf-1" />
            <i className="falling-leaf falling-leaf-2" />
            <i className="falling-leaf falling-leaf-3" />
            <i className="falling-leaf falling-leaf-4" />
            <i className="falling-leaf falling-leaf-5" />
            <i className="falling-leaf falling-leaf-6" />
            <i className="falling-leaf falling-leaf-7" />
            <i className="falling-leaf falling-leaf-8" />
            <i className="falling-leaf falling-leaf-9" />
            <i className="falling-leaf falling-leaf-10" />
            <i className="falling-leaf falling-leaf-11" />
            <i className="falling-leaf falling-leaf-12" />
          </div>
        </div>

        <div className="invite-page">
          <button
            className={`music-toggle ${musicPlaying ? 'is-playing' : ''}`}
            type="button"
            onClick={toggleMusic}
            aria-pressed={musicPlaying}
          >
            <span className="music-bars" aria-hidden="true"><i /><i /><i /></span>
            {musicPlaying ? 'Pause' : 'Music'}
          </button>
          <audio ref={audioRef} className="background-audio" src={backgroundMusic} autoPlay loop preload="auto" />

          <section className="cover" id="top">
            <p className="cover-kicker">The Wedding Invitation</p>
            <div className="cover-couple-frame">
              <div className="cover-leaf-frame" aria-hidden="true">
                <i className="cover-leaf cover-leaf-top-1" />
                <i className="cover-leaf cover-leaf-top-2" />
                <i className="cover-leaf cover-leaf-top-3" />
                <i className="cover-leaf cover-leaf-top-4" />
                <i className="cover-leaf cover-leaf-right-1" />
                <i className="cover-leaf cover-leaf-right-2" />
                <i className="cover-leaf cover-leaf-right-3" />
                <i className="cover-leaf cover-leaf-bottom-1" />
                <i className="cover-leaf cover-leaf-bottom-2" />
                <i className="cover-leaf cover-leaf-bottom-3" />
                <i className="cover-leaf cover-leaf-left-1" />
                <i className="cover-leaf cover-leaf-left-2" />
                <i className="cover-leaf cover-leaf-left-3" />
              </div>
              <video
                className="cover-couple-gif"
                src={coupleHugVideo}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                aria-label="A bride and groom hugging"
              />
            </div>
            <h1 className="names">
              <span>{wedding.groom}</span>
              <span className="ampersand">&amp;</span>
              <span>{wedding.bride}</span>
            </h1>
            <div className="ornament" aria-hidden="true"><span>◆</span></div>
            <p className="cover-call">We are getting married</p>

            {/* <div className="date-lockup">
              <span className="day">{wedding.day}</span>
              <span className="month-year"><strong>{wedding.month}</strong><small>{wedding.year}</small></span>
            </div> */}

            <button className="join-button" type="button" onClick={scrollToDetails}>
              Please join us <span aria-hidden="true">↓</span>
            </button>

          </section>

          <section className="section soft" id="details">
            <p className="eyebrow">A little note from us</p>
            <h2 className="section-title">Our happy beginning</h2>
            <p className="section-copy">
              We would love for you to be part of the day we say yes to forever. Your presence will make our celebration complete.
            </p>
            <p className="intro-quote">“The best thing to hold onto in life is each other.”</p>

            <div className="date-lockup">
              <span className="day">{wedding.day}</span>
              <span className="month-year"><strong>{wedding.month}</strong><small>{wedding.year}</small></span>
            </div>

            <div className="countdown" aria-label="Countdown to the wedding">
              <div className="countdown-card"><strong>{countdown.days}</strong><span>Days</span></div>
              <div className="countdown-card"><strong>{countdown.hours}</strong><span>Hours</span></div>
              <div className="countdown-card"><strong>{countdown.minutes}</strong><span>Minutes</span></div>
              <div className="countdown-card"><strong>{countdown.seconds}</strong><span>Seconds</span></div>
            </div>
          </section>

          <section className="section" id="schedule">
            <div className="timeline-heading">
              <p className="eyebrow">Save the date</p>
              <h2 className="timeline-title">Wedding Timeline</h2>
              <span className="mini-script">29 / 10 / 26</span>
            </div>

            <div className="schedule">
              {eventSchedule.map((item, index) => (
                <article className={`schedule-item ${index % 2 === 0 ? 'schedule-item-left' : 'schedule-item-right'}`} key={item.label}>
                  <div className="schedule-content">
                    <div className="schedule-icon"><EventIcon type={item.icon} /></div>
                    <span className="schedule-time">{item.time}</span>
                    <h3 className="schedule-label">{item.label}</h3>
                    <p className="schedule-note">{item.note}</p>
                  </div>
                  <span className="schedule-node" aria-hidden="true" />
                </article>
              ))}
            </div>

            <div className="venue-panel">
              <p className="venue-name">{wedding.venue}</p>
              <p className="venue-address">{wedding.address} · {wedding.time}</p>
              <iframe
                className="map-preview"
                title={`Map to ${wedding.venue}`}
                src="https://www.google.com/maps?q=Vinrich+Lake+Resort+Piliyandala&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <a className="text-link" href={wedding.mapUrl} target="_blank" rel="noreferrer">View on Google Maps</a>
            </div>
          </section>

          <section className="section soft story-section" id="story">
            <p className="eyebrow">Two hearts, one story</p>
            <h2 className="section-title">Made for each other</h2>
            <img className="couple-image" src={coupleIllustration} alt="A couple walking together through flowers" />
            <p className="section-copy">From this day forward, our favourite place will always be next to one another.</p>
          </section>

          <section className="section" id="rsvp">
            <p className="eyebrow">We hope you can make it</p>
            <h2 className="section-title">Kindly RSVP</h2>
            {rsvpSent ? (
              <div className="rsvp-card"><p className="thanks">Thank you — we can’t wait to celebrate with you!</p></div>
            ) : (
              <form className="rsvp-card" onSubmit={submitRsvp}>
                <div className="field"><label htmlFor="guest-name">Your name</label><input id="guest-name" name="guestName" placeholder="Enter your name" required /></div>
                <div className="field"><label htmlFor="guest-mobile">Mobile number</label><input id="guest-mobile" name="guestMobile" type="tel" inputMode="tel" autoComplete="tel" placeholder="Enter your mobile number" required /></div>
                <div className="field"><label htmlFor="attendance">Will you attend?</label><select id="attendance" name="attendance" defaultValue="yes"><option value="yes">Joyfully accepts</option><option value="no">Regretfully declines</option></select></div>
                {rsvpError && <p className="form-error" role="alert">{rsvpError}</p>}
                <button className="submit-button" type="submit" disabled={rsvpSubmitting}>{rsvpSubmitting ? 'Sending RSVP…' : 'Send RSVP'}</button>
              </form>
            )}
          </section>

          <footer className="footer">
            <p className="footer-script">Forever starts here</p>
            <p className="footer-copy">With love, {wedding.groom} &amp; {wedding.bride} · {wedding.year}</p>
          </footer>
        </div>
      </main>
    </>
  );
}

export default Invite;
